<script setup>
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['closed'])

const QuickEmailSignup = defineAsyncComponent(
  () => import('@/components/Index/QuickEmailSignup'),
)
const QesThankYou = defineAsyncComponent(
  () => import('@/components/Index/QesThankYou'),
)

const showThankYou = ref(false)
const modalClasses = 'qes-modal-dialog modal-container home-email-modal'

watch(
  () => props.open,
  (isOpen) => {
    if (!isOpen) {
      showThankYou.value = false
    }
  },
)

const close = () => {
  emit('closed')
}

const handleRegisterSuccess = () => {
  showThankYou.value = true
}
</script>

<template>
  <transition name="modal">
    <div v-if="open" class="modal-mask" @click="close">
      <div :class="`${modalClasses} qes-modal-old`" @click.stop>
        <QesThankYou v-if="showThankYou" />
        <QuickEmailSignup
          v-else
          :auto-focus="true"
          @closed="close"
          @register-success="handleRegisterSuccess"
        />
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import '../../assets/scss/components/quickEmailSignUpModal/quick-email-signup-modal.scss';
</style>
